import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

import Login           from './pages/Login';
import Dashboard       from './pages/Dashboard';
import TicketList      from './pages/TicketList';
import NewTicket       from './pages/NewTicket';
import ViewTicket      from './pages/ViewTicket';
import EditTicket      from './pages/EditTicket';
import UserManagement  from './pages/UserManagement';
import DropdownManager from './pages/DropdownManager';
import ChangePassword  from './pages/ChangePassword';

function Protected({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
}
function AdminOnly({ children }) {
  const { user, isAdmin } = useAuth();
  if (!user)    return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/"      replace />;
  return children;
}
function CanCreate({ children }) {
  const { user, canCreate } = useAuth();
  if (!user)      return <Navigate to="/login"   replace />;
  if (!canCreate) return <Navigate to="/tickets" replace />;
  return children;
}
function CanEdit({ children }) {
  const { user, canEdit } = useAuth();
  if (!user)    return <Navigate to="/login"   replace />;
  if (!canEdit) return <Navigate to="/tickets" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login"                   element={<Login />} />
          <Route path="/"                        element={<Protected><Dashboard /></Protected>} />
          <Route path="/tickets"                 element={<Protected><TicketList /></Protected>} />
          <Route path="/tickets/new"             element={<CanCreate><NewTicket /></CanCreate>} />
          <Route path="/tickets/:ticket_id"      element={<Protected><ViewTicket /></Protected>} />
          <Route path="/tickets/:ticket_id/edit" element={<CanEdit><EditTicket /></CanEdit>} />
          <Route path="/users"                   element={<AdminOnly><UserManagement /></AdminOnly>} />
          <Route path="/dropdowns"               element={<AdminOnly><DropdownManager /></AdminOnly>} />
          <Route path="/change-password"         element={<Protected><ChangePassword /></Protected>} />
          <Route path="*"                        element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
